/**
 * Minimal modal thumbnail page — no auth, no API, no Firestore.
 * Used for inline iframe previews of device modal templates in the Marketplace.
 * Renders the modal with mock device data.
 */
import { Suspense } from 'react'
import { useParams } from 'react-router-dom'
import { getModalTemplateById } from '../../ultron-turing-manager/src/registry/deviceModalTemplateRegistry'
import './AppSuiteTemplateThumbnailPage.css'

const MOCK_DEVICES: Record<string, { sn: string; name: string; type: string }> = {
  DEHUMIDIFIER:          { sn: 'MOCK-DEHUMIDIFIER-01', name: 'Smart Dehumidifier', type: 'DEHUMIDIFIER' },
  WATER_DISPENSER:       { sn: 'MOCK-WD-01',           name: 'Water Dispenser',    type: 'WATER_DISPENSER' },
  ULTRON_WATER_DISPENSER:{ sn: 'MOCK-UWD-01',          name: 'Water Dispenser',    type: 'ULTRON_WATER_DISPENSER' },
  AC_UNIT:               { sn: 'MOCK-AC-01',            name: 'Living Room AC',     type: 'AC_UNIT' },
  LIGHT:                 { sn: 'MOCK-LIGHT-01',         name: 'Bedroom Light',      type: 'LIGHT' },
  FAN:                   { sn: 'MOCK-FAN-01',           name: 'Standing Fan',       type: 'FAN' },
  AIRPURIFIER:           { sn: 'MOCK-AP-01',            name: 'Air Purifier',       type: 'AIRPURIFIER' },
  SWITCH:                { sn: 'MOCK-SW-01',            name: 'Wall Switch',        type: 'SWITCH' },
  CURTAIN:               { sn: 'MOCK-CUR-01',           name: 'Window Curtain',     type: 'CURTAIN' },
  BLINDS:                { sn: 'MOCK-BLD-01',           name: 'Office Blinds',      type: 'BLINDS' },
}

export default function AppSuiteModalThumbnailPage() {
  const { modalId } = useParams<{ modalId: string }>()
  const entry = modalId ? getModalTemplateById(modalId) : null

  if (!entry) {
    return (
      <div className="tmpl-thumbnail-outer">
        <div style={{ color: '#ef4444', fontSize: 14 }}>Unknown modal: {modalId}</div>
      </div>
    )
  }

  const primaryType = entry.deviceTypes[0] || 'UNKNOWN'
  const mockDevice = MOCK_DEVICES[primaryType] ?? {
    sn: 'MOCK-001',
    name: 'Mock Device',
    type: primaryType,
  }

  const ModalComponent = entry.component

  return (
    <div className="tmpl-thumbnail-outer">
      <div className="tmpl-thumbnail-frame">
        <Suspense fallback={null}>
          <ModalComponent
            device={{ ...mockDevice, online: true }}
            deviceState={null}
            deviceType={mockDevice.type}
            onCommand={() => {}}
            onClose={() => {}}
            credentials={undefined}
          />
        </Suspense>
      </div>
    </div>
  )
}
